<script>
  import DynamicH2 from "../common/DynamicH2.svelte";
  import TextInput from "./TextInput.svelte";

  // export let titleVisible = false;
</script>

<style>
  ::-webkit-scrollbar {
    display: none;
  }

  img {
    filter: invert(100%);
    -webkit-filter: invert(100%);
    width: 500px;
    /* max-width: 100%; */
  }

  .outer {
    position: relative;
    width: 100%;
    height: 100%;
  }

  .inner {
    position: absolute;
    /* background: lightcoral; */
    border-bottom-left-radius: 32.5px;
    border-bottom-right-radius: 32.5px;
    height: 448.5px;
    max-height: 448.5px;
    overflow: hidden;
    left: 136px;
    top: 40px;
    width: 235px;
  }

  .inner header {
    border-bottom: 1px solid white;
    font-weight: bold;
    height: 40px;
    width: 100%;
  }

  .inner #body {
    border-bottom: 0.5px solid white;
    overflow-y: scroll;
    width: 100%;
    /* Shadow */
    box-shadow: 0px -2px 5px 0px rgba(0, 0, 0, 0.5) inset;
    -webkit-box-shadow: 0px -2px 5px 0px rgba(0, 0, 0, 0.5) inset;
    -moz-box-shadow: 0px -2px 5px 0px rgba(0, 0, 0, 0.5) inset;
  }

  .message-wrapper {
    /* background: red; */
    display: flex;
    font-size: 0.8rem;
    margin: 10px 0;
  }

  .message-wrapper div {
    border-radius: 0.8rem;
    margin: 0 10px;
    padding: 2.5px 10px;
    width: max-content;
    max-width: 60%;
  }

  .message-wrapper .cpu {
    border: 2px solid white;
  }

  .message-wrapper .user {
    background: rgba(255, 255, 255, 0.3);
    margin-left: auto;
    /* Shadow */
    box-shadow: 2px 2px 4px 0px rgba(255, 255, 255, 0.5);
    -webkit-box-shadow: 2px 2px 4px 0px rgba(255, 255, 255, 0.5);
    -moz-box-shadow: 2px 2px 4px 0px rgba(255, 255, 255, 0.5);
  }

  .inner span {
    align-items: flex-end;
    margin: 10px 0;
    /* justify-self: center; */
    text-align: center;
    width: 90%;
  }

  .inner button {
    border: 1px solid white;
    border-radius: 25px;
    cursor: pointer;
    height: 25px;
    margin-left: 5px;
    padding: 1px;
    width: 25px;
  }

  .inner button:focus {
    outline: none;
  }
</style>

<div>
  <DynamicH2 inputText={'Communicate with Fred the way you best see fit.'} />

  <!-- Mobile phone -->
  <div class="outer">
    <img
      src="https://cdn0.iconfinder.com/data/icons/apple-products-2032/1772/iphone_x-512.png"
      alt="Mobile Phone" />

    <!-- <img
      src="https://cdn1.iconfinder.com/data/icons/smartphone-and-tablet-outline/100/google_nexus-512.png"
      alt="Mobile Phone" /> -->

    <div class="inner flex-col items-center">
      <header class="flex-row justify-center items-center">Fred</header>

      <div id="body" class="flex-1">
        <div class="message-wrapper">
          <div class="user">This is a message</div>
        </div>

        <div class="message-wrapper">
          <div class="cpu">
            This is a message that happens to be longer than the others.
          </div>
        </div>

        <div class="message-wrapper">
          <div class="user">This is a message</div>
        </div>

        <div class="message-wrapper">
          <div class="user">This is a message. Longer and longer isn't it!</div>
        </div>

        <div class="message-wrapper">
          <div class="cpu">How can I help you?</div>
        </div>

        <div class="message-wrapper">
          <div class="user">This is a message. Longer and longer isn't it!</div>
        </div>

        <div class="message-wrapper">
          <div class="cpu">How can I help you?</div>
        </div>
      </div>

      <span class="flex-row">
        <TextInput />
        <button class="clear-element flex-row items-center justify-center">
          <i class="far fa-paper-plane" />
        </button>
      </span>
    </div>
  </div>

</div>
